import { useEffect, useRef } from 'react';
import { useAuthenticatedFetch } from './useAuthenticatedFetch';

/**
 * Idempotently register / refresh the storefront Web Pixel for this shop on app
 * load (decision-0010, Phase B).
 *
 * Fire-and-forget: pixel activation must never block or error the admin UI (the
 * backend no-ops when the settings already match). It requires the write_pixels
 * scope — before the merchant re-consents this simply logs and is ignored, then
 * self-heals on the next load once the scope is granted.
 */
export function useEnsurePixel(): void {
  const authenticatedFetch = useAuthenticatedFetch();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // run once per mount
    ran.current = true;

    authenticatedFetch('/api/pixel/ensure', { method: 'POST' })
      .then((res) => res.json().catch(() => null))
      .then((json) => {
        if (json?.success) {
          console.log('[Pixel] ensure:', json.data?.action);
        } else {
          console.warn('[Pixel] ensure not completed (pending write_pixels consent?)');
        }
      })
      .catch((err) => console.warn('[Pixel] ensure call failed:', err));
  }, [authenticatedFetch]);
}
